import * as React from 'react';
import RichText from '../RichText/RichText';

const TextItem = ({ content }) => (
    <RichText className="p-8 bg-white border shadow rounded text-gray-700" json={content.json} />
);

export default TextItem;